import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { EXPERIENCES } from "@/data/siteData";

export default function Experiences() {
  const planExperience = (interest) => {
    window.dispatchEvent(new CustomEvent("rtg:plan-experience", { detail: interest }));
  };

  return (
    <section id="experiences" data-testid="experiences-section" className="py-20 sm:py-28 px-5 sm:px-8 max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-12 sm:mb-16"
      >
        <p className="text-[11px] sm:text-xs uppercase tracking-[0.32em] text-gold font-semibold mb-4">Curated Goa Experiences</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-2xl">
          Every Side of <span className="gold-text italic">Goa</span>, One Call Away
        </h2>
        <p className="mt-4 text-sm sm:text-base text-slate-400 max-w-xl leading-relaxed">
          Pick what excites you — we will plan it around your dates, budget and travel style.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
        {EXPERIENCES.map((ex, i) => (
          <motion.div
            key={ex.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ delay: (i % 3) * 0.1, duration: 0.65 }}
            data-testid={`experience-card-${ex.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="group rounded-3xl overflow-hidden border border-[#DC2626]/20 hover:border-gold/60 shadow-sm hover:shadow-lg bg-white transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1 flex flex-col"
          >
            <div className="h-44 sm:h-52 overflow-hidden">
              <img
                src={ex.image}
                alt={ex.alt}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-110"
              />
            </div>
            <div className="p-5 sm:p-6 flex flex-col flex-1">
              <p className="text-[10px] uppercase tracking-[0.3em] text-gold font-bold">{ex.tag}</p>
              <h3 className="font-display text-xl sm:text-2xl font-bold text-gold mt-1.5">{ex.title}</h3>
              <p className="mt-2 text-[13px] text-slate-400 leading-relaxed flex-1">{ex.desc}</p>
              <button
                type="button"
                onClick={() => planExperience(ex.interest)}
                data-testid={`plan-experience-btn-${ex.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="mt-5 inline-flex items-center justify-center gap-2 w-full border border-gold/50 text-gold-light text-sm font-semibold py-3 rounded-full hover:bg-gold hover:text-white transition-[background-color,color,border-color] duration-300 active:scale-[0.98]"
              >
                <Sparkles className="w-4 h-4" />
                Plan My Experience
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
